class Snapslider {
	constructor(element, options = {}) {
		this.slider = element;
		this.settings = jQuery.extend(
			{
				card_selector: '.js-snapslider_item',
				card_pagination: '.js-snapslider_pagination',
				dots_container_class: 'snapslider_pagination',
				dot_class: 'snapslider__dot',
				active_dot_class: 'snapslider__dot--active',
				data_attrs: element.data(),
			},
			options
		);
		
		this.cards = this.slider.find(this.settings.card_selector);
		this.dots_container = jQuery(`.js-${this.settings.id}_pagination`);
		this.dots = null;
		
		this.init();
	}
	init() {
		this.remove_existing_dots();
		this.create_dots();
		this.bind_scroll_event();
		this.set_initial_active_dot()
			.then((index) => {
				if (this.settings.data_attrs.focus_first) {
					this.slider[0].scrollLeft = 0;
				} else {
					this.scroll_to_center();
				}
			});
	}
	remove_existing_dots() {
		this.slider
			.next(`.${this.settings.dots_container_class}`)
			.remove();
	}
	create_dots() {
		this.cards.each((index) => {
			const dot = jQuery('<button>')
				.addClass(this.settings.dot_class)
				.attr('type', 'button')
				.attr('aria-label', `Go to slide ${index + 1}`)
				.on('click', () => this.scroll_to_card(index));
			this.dots_container.append(dot);
		});
		
		this.dots = this.dots_container.find(
			`.${this.settings.dot_class}`
		);
	}
	scroll_to_card(index) {
		const card = this.cards[index];
		const slider = this.slider[0];
		
		const target_scroll_left =
			card.offsetLeft - slider.offsetLeft;
		
		slider.scrollTo({
			left: target_scroll_left,
			behavior: 'smooth',
		});
	}
	scroll_to_center() {
		const center_index = Math.floor(this.cards.length / 2);
		const card = this.cards[center_index];
		const slider = this.slider[0];
		
		const scroll_left =
			card.offsetLeft -
			(slider.clientWidth - card.clientWidth) / 2;
		
		slider.scrollTo({
			left: scroll_left,
			behavior: 'auto',
		});
	}
	bind_scroll_event() {
		this.slider.on('scroll.slider_dots', () => {
			this.init_sync_scroll(this.slider.scrollLeft());
			this.update_active_dot();
		});
	}
	init_sync_scroll(value) {
		get_all_snapsliders_components().forEach((component_key) => {
			jQuery(`.js-${component_key}`).data('sl_value', value);
		});
	}
	update_active_dot() {
		let active_index = 0;
		let min_distance = Infinity;
		
		const slider_left =
			this.slider[0].getBoundingClientRect().left;
		
		this.cards.each((index, card) => {
			const distance = Math.abs(
				card.getBoundingClientRect().left - slider_left
			);
			
			if (distance < min_distance) {
				min_distance = distance;
				active_index = index;
			}
		});
		
		this.dots
			.removeClass(this.settings.active_dot_class)
			.eq(active_index)
			.addClass(this.settings.active_dot_class);
	}
	
	set_initial_active_dot() {
		return new Promise((resolve) => {
			if (!this.dots || !this.dots.length) {
				resolve();
				return;
			}
			
			this.dots
				.removeClass(this.settings.active_dot_class)
				.eq(0)
				.addClass(this.settings.active_dot_class);
			
			resolve(0); // resolve with active index
		});
	}
}
const waitForElement = (selector) => {
	return new Promise(resolve => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}
		
		const observer = new MutationObserver(mutations => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});
		
		observer.observe(document.body, { childList: true, subtree: true });
	});
};
function get_all_snapsliders_components() {
	return Object.keys(yalwa.v.components).filter(key =>
		key.startsWith('snapslider_')
	);
}
async function init_sliders() {
	const keys = get_all_snapsliders_components(); // Using the sync version from before

	for (const component_key of keys) {
		const selector = `.js-${component_key}`;
		
		// Wait for this specific element to exist in the DOM
		await waitForElement(selector);
		
		const $slider = jQuery(selector);
		if (yalwa.v.component_instances[component_key]) {
			continue;
		}
		
		yalwa.v.component_instances[component_key] = new Snapslider($slider, {
			id: component_key,
			unique_ID: $slider.data('unique_id')
		});
	}
}
//On Load by default
init_sliders();